import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { useState, useEffect } from "react";
import { useTheme } from "@/contexts/ThemeContext";

const STORAGE_KEY = 'promo_banner_dismissed';

const PromoBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { theme } = useTheme();

  useEffect(() => {
    const isDismissed = localStorage.getItem(STORAGE_KEY);
    if (!isDismissed) {
      setIsVisible(true);
    }
  }, []);

  const handleDismiss = () => {
    localStorage.setItem(STORAGE_KEY, 'true');
    setIsVisible(false);
    // Dispatch custom event to notify header
    window.dispatchEvent(new CustomEvent('promoBannerDismissed'));
  };

  if (!isVisible) return null;

  return (
    <div 
      className="w-full py-2.5 px-4 relative z-[60]"
      style={{ 
        backgroundColor: theme === 'dark' ? '#f4f2f1' : '#111111',
        borderBottom: theme === 'dark' ? '1px solid rgba(0,0,0,0.08)' : '1px solid rgba(255,255,255,0.1)'
      }}
    >
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-2 text-sm">
        <span 
          className="font-medium"
          style={{ color: theme === 'dark' ? '#111111' : '#FFFFFF' }}
        >
          🎉 Limited Time: <span className="font-bold">50% OFF</span> all plans with code{" "}
          <code 
            className="px-1.5 py-0.5 rounded font-mono font-bold"
            style={{ 
              backgroundColor: theme === 'dark' ? 'rgba(0,0,0,0.08)' : 'rgba(255,255,255,0.15)',
              color: theme === 'dark' ? '#111111' : '#FFFFFF'
            }}
          >
            STORILY50
          </code>
        </span>
        <Link 
          to="/pricing#pricing-tables"
          className="ml-2 underline underline-offset-2 hover:no-underline font-medium"
          style={{ color: theme === 'dark' ? '#111111' : '#FFFFFF' }}
        >
          Get Offer →
        </Link>
        <button
          onClick={handleDismiss}
          className="absolute right-4 top-1/2 -translate-y-1/2 p-1 rounded transition-colors"
          style={{ 
            color: theme === 'dark' ? '#111111' : '#FFFFFF'
          }}
          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = theme === 'dark' ? 'rgba(0,0,0,0.05)' : 'rgba(255,255,255,0.1)'}
          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
          aria-label="Dismiss banner"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default PromoBanner;
